module.exports = __webpack_public_path__ + "img/Banner640Art.2477583d.png";